// /api/auth-me answers with THIS browser's session identity, so no cache may serve a stored
// response: a stale 200 kept a dead session looking alive (bug-muenvnj8-70z5 — an authenticated
// identity record was replayed byte-identical ~132s after generation, after /api/usage had already
// rejected the session). Serving caches key function responses by URL + query with no cookie
// dimension (`netlify-vary: query`), so every request carries a fresh cachebust value and a stored
// entry can never match — every auth-me request reaches the handler even where its no-store
// headers are ignored.
let cacheBust = 0

export function authMeUrl(): string {
  return `/api/auth-me?cachebust=${Date.now()}-${++cacheBust}`
}
